<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-grid">
        <!-- 品牌 -->
        <div>
          <div style="display:flex;align-items:center;gap:11px;margin-bottom:14px">
            <span class="logo"></span>
            <span>
              <span class="brand-cn">易隆创</span>
              <span class="brand-en">YILONGCHUANG</span>
            </span>
          </div>
          <p>新基建领域首个行业生态平台。<br>通过技术驱动生态融合，致力于成为新型基础建设领域数字业务的"基石"。</p>
        </div>
        <!-- 生态入口 -->
        <div>
          <b>四大生态</b>
          <ul>
            <li v-for="eco in ecosystems" :key="eco.slug">
              <router-link :to="`/ecosystem/${eco.slug}`">{{ eco.index }} · {{ eco.name }}</router-link>
            </li>
          </ul>
        </div>
        <!-- 快速链接 -->
        <div>
          <b>快速链接</b>
          <ul>
            <li><router-link to="/personas">目标人群</router-link></li>
            <li><router-link to="/join">加入流程</router-link></li>
            <li><router-link to="/register">免费注册</router-link></li>
            <li><router-link to="/login">登录</router-link></li>
          </ul>
        </div>
        <!-- 联系我们 -->
        <div>
          <b>关注我们</b>
          <p>电话：400-009-2860</p>
          <p>邮箱：admin@longstron.com</p>
          <p>地址：南京市雨花台区宁双路19号<br>云密城F栋12层</p>
        </div>
      </div>
    </div>
    <div class="copyright">
      Copyright © 2019-{{ year }} 隆创信息有限公司 All Rights Reserved.
      <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备14056357号-5</a>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppFooter',
  computed: {
    ...mapState('ecosystem', ['ecosystems']),
    year() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="less" scoped>
.app-footer {
  background: #02060e;
  border-top: 1px solid var(--line);
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.25fr 0.8fr 0.8fr 1fr;
  gap: 40px;
  padding: 55px 0;
  color: #73809b;
  font-size: 13px;

  b {
    color: #fff;
    display: block;
    margin-bottom: 4px;
  }
  p {
    margin-top: 4px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 12px 0 0;
    display: grid;
    gap: 8px;
  }
  li a {
    color: #73809b;
    text-decoration: none;
    &:hover {
      color: #67dbff;
    }
  }

}

.logo {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: linear-gradient(135deg, var(--cyan), #2875ec);
  display: grid;
  place-items: center;
  flex-shrink: 0;
  &::before {
    content: "易";
    color: #fff;
    font-weight: 800;
    font-size: 15px;
  }
}
.brand-cn {
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #fff;
  font-size: 14px;
}
.brand-en {
  font-size: 9px;
  color: #7f8ba6;
  letter-spacing: 0.18em;
  display: block;
}

.copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  text-align: center;
  padding: 20px;
  color: #59647b;
  font-size: 11px;

  a {
    color: #59647b;
    margin-left: 12px;
    text-decoration: none;
    &:hover {
      color: #67dbff;
    }
  }
}
</style>
